import { getCurrentInstance, computed } from 'vue';
import { roundingNum } from '@/common/utils';
import { Picture } from '~/api/topic';

type PictureActionItemProps = {
    index?: number;
    picture?: Picture;
    isLoginStatus?: boolean;
};

export const PictureActionItemCommonSetup = (props: PictureActionItemProps) => {
    const { proxy } = getCurrentInstance() as { proxy: any };

    const likeCount = props.picture?.like_count ?? 0;
    const commentCount = props.picture?.comment_count ?? 0;

    const formattedLikeCount = computed(() => {
        return likeCount > 0 ? roundingNum(likeCount) : proxy?.$root?.$t('k_344306') ?? '';
    });

    const formattedCommentCount = computed(() => {
        return commentCount > 0 ? roundingNum(commentCount) : proxy?.$root?.$t('k_467898') ?? '';
    });

    const formattedDownloadCount = computed(() => proxy?.$root?.$t('download') ?? '');

    return {
        formattedLikeCount,
        formattedCommentCount,
        formattedDownloadCount,
    };
};
